<template>
	<modal ref="modalOk">
		<button type="button" class="close" @click="clickVoltar()">
			<span aria-hidden="true">&times;</span>
		</button>
		<h4 class="modal-title">
			{{ titulo.toUpperCase() }}
		</h4>

		<hr />

		<h2 class="text-center text-success"><i class="fa fa-check-circle"></i> {{ textoSucesso.toUpperCase() }}</h2>

		<h2 class="text-center">
			<strong>{{ descricao }}</strong>
		</h2>

		<button class="btn btn-default" type="button" @click="clickVoltar()">
			<i class="icon-left"></i> {{ _traducao('menuAGcadAluno', 'voltarParaLista') }}
		</button>
	</modal>
</template>

<script>
export default {
	props: {
		titulo: {
			type: String,
			required: true
		},
		textoSucesso: {
			type: String,
			required: true
		},
		descricao: {
			type: String,
			required: true
		},
		rotaVoltar: {
			type: String,
			required: true
		},
		abrir: {
			type: Boolean,
			default: false
		}
	},
	watch: {
		abrir(newValue, oldValue) {
			console.log(oldValue, newValue)
			if (oldValue != newValue) {
				if (newValue) {
					this.$refs.modalOk.modalShow()
				}
			}
		}
	},
	methods: {
		clickVoltar() {
			this.$refs.modalOk.modalHide()
			this.$router.push({name: this.rotaVoltar})
		}
	}
}
</script>